import { useCallback } from 'react';
import { Visitor as ApiVisitor } from 'store/api-client/api-client.types';

interface VisitorDropdownItemProps {
  visitor: ApiVisitor;
  onSelect: (visitor: ApiVisitor) => void;
  subtitleField?: 'email' | 'phone' | 'both';
}

export const VisitorDropdownItem = ({
  visitor,
  onSelect,
  subtitleField = 'both',
}: VisitorDropdownItemProps): JSX.Element => {
  const handleClick = useCallback(() => {
    onSelect(visitor);
  }, [visitor, onSelect]);

  const getSubtitle = () => {
    if (subtitleField === 'email') {
      return visitor.email;
    }
    if (subtitleField === 'phone') {
      return visitor.phone;
    }
    return [visitor.email, visitor.phone].filter(Boolean).join(' • ');
  };

  const subtitle = getSubtitle();

  return (
    <button
      type="button"
      onClick={handleClick}
      className="w-full px-3 py-2 text-left hover:bg-gray-100 focus:bg-gray-100 focus:outline-none"
    >
      <div className="flex flex-col">
        <span className="text-sm font-medium text-gray-900">
          {visitor.first_name} {visitor.last_name}
        </span>
        {subtitle && <span className="text-xs text-gray-500">{subtitle}</span>}
      </div>
    </button>
  );
};
